import React from 'react';
import { AkinatorSkeleton } from './akinator/akinator-skeleton';

export const SuggestionPreloader = () => {
  return (
    <div data-qa="suggestion-preloader">
      <AkinatorSkeleton />
    </div>
  );
};
